import React from 'react';

import { SubHeading, MenuItem } from '../../components';
import FamilyDinnerItem from '../../components/Menuitem/FamilyDinnerItem';
import { images, data } from '../../constants';
import './SpecialMenu.css';
import ComboItem from '../../components/Menuitem/ComboItem';

const SpecialMenu = () => (
  <div className='app__specialMenu flex__center section__padding' id="menu">
    <div className='app__specialMenu-title'>
      <SubHeading title="Menu That Fits Your Palatte"></SubHeading>
      <h1 className='headtext__cormorant'>Menu</h1>
    </div>

    {/* Appetiziers */}
    <div className='app__specialMenu-menu'>
      <div className='app__specialMenu-menu_special flex__center'>
        <p className='app__specialMenu-menu_heading'>Appetizers</p>
        <div className='app__specialMenu_menu_items'>
          {data.appetizers.map((appetizers, index) => (
            <MenuItem key={appetizers.title + index} title={appetizers.title} price={appetizers.price} tags={appetizers.tags}/>
          ))}
        </div>
      </div>

      {/*      
      <div className='app__specialMenu-menu_img'>
        <img src={images.menu} alt="menu img"></img>
      </div>
          */}

      <div className='app__specialMenu-menu_soup flex__center'>
        <p className='app__specialMenu-menu_heading'>Soups</p>
        <div className='app__specialMenu_menu_items'>
          {data.soups.map((soups, index) => (
            <MenuItem key={soups.title + index} title={soups.title} price={soups.price} tags={soups.tags}/>
          ))}
        </div>
      </div>    
    </div>
    
    {/* Family Dinners */}
    <div className='app__specialMenu-menu_familyDinners'>
      <div className='app__specialMenu-menu_familyDinner flex__center'>
        <p className='app__specialMenu-menu_heading'>Family Size Dinners</p>
        <div className='app__specialMenu_menu_items_fd'>
          {data.familyDinner.map((familyDinner, index)  => (
            <FamilyDinnerItem key={familyDinner.title + index} style={{padding: '20px' }} title={familyDinner.title} price={familyDinner.price} items={familyDinner.items} tags={familyDinner.tags}/>
          ))}
        </div>
      </div>   
    </div>
    
    {/* Combination Dinners */}
    <div className='app__specialMenu-menu_Combos'>
      <div className='app__specialMenu-menu_Combo flex__center'>
        <p className='app__specialMenu-menu_heading'>Combination Plates</p>
        <div className='app__specialMenu_menu_items_combos'>
          {data.combos.map((combos, index)  => (
            <ComboItem key={combos.title + index} style={{padding: '20px' }} title={combos.title} price={combos.price} items={combos.items}/>
          ))}
        </div>
      </div>   
    </div>
    
    {/* Entrees */}
        {/* Beef */}
    <div className='app__specialMenu-menu_entrees'>
      <div className='app__specialMenu-menu_entree flex__center'>
        <p className='app__specialMenu-menu_heading'>Beef Entrees</p>
        <div className='app__specialMenu_menu_items'>
          {data.beef.map((beef, index) => (
            <MenuItem key={beef.title + index} title={beef.title} price={beef.price} tags={beef.tags}/>
          ))}
        </div>
      </div>   
    

    {/* seafood entrees */}        
    <div className='app__specialMenu-menu_seafood flex__center'>
        <p className='app__specialMenu-menu_heading'>Seafood Entrees</p>
        <div className='app__specialMenu_menu_items'>
          {data.seafood.map((seafood, index) => (
            <MenuItem key={seafood.title + index} title={seafood.title} price={seafood.price} tags={seafood.tags}/>
          ))}
        </div>
      </div>

      {/* Chicken entrees */}
      <div className='app__specialMenu-menu_chicken flex__center'>
        <p className='app__specialMenu-menu_heading'>Chicken Entrees</p>
        <div className='app__specialMenu_menu_items'>
          {data.chicken.map((chicken, index) => (
            <MenuItem key={chicken.title + index} title={chicken.title} price={chicken.price} tags={chicken.tags}/>
          ))}
        </div>
      </div>  

      {/* Pork entrees */}
      <div className='app__specialMenu-menu_pork flex__center'>
        <p className='app__specialMenu-menu_heading'>Pork Entrees</p>
        <div className='app__specialMenu_menu_items'>
          {data.pork.map((pork, index) => (
            <MenuItem key={pork.title + index} title={pork.title} price={pork.price} tags={pork.tags}/>
          ))}
        </div>
      </div>

      {/* Chowmein entrees */}
      <div className='app__specialMenu-menu_chowmein flex__center'>
        <p className='app__specialMenu-menu_heading'>Chow Mein Entrees</p>
        <div className='app__specialMenu_menu_items'>
          {data.chowMein.map((chowMein, index) => (
            <MenuItem key={chowMein.title + index} title={chowMein.title} price={chowMein.price} tags={chowMein.tags}/>
          ))}
        </div>
      </div> 

      {/* Fried Rice entrees */}
      <div className='app__specialMenu-menu_friedRice flex__center'>
        <p className='app__specialMenu-menu_heading'>Fried Rice Entrees</p>
        <div className='app__specialMenu_menu_items'>
          {data.friedRice.map((friedRice, index) => (
            <MenuItem key={friedRice.title + index} title={friedRice.title} price={friedRice.price} tags={friedRice.tags}/>
          ))}
        </div>
      </div>

      {/* NoodleBowl entrees */}
      <div className='app__specialMenu-menu_noodleBowl flex__center'>
        <p className='app__specialMenu-menu_heading'>Noodle Bowl Entrees</p>
        <div className='app__specialMenu_menu_items'>
          {data.noodleBowl.map((noodleBowl, index) => (
            <MenuItem key={noodleBowl.title + index} title={noodleBowl.title} price={noodleBowl.price} tags={noodleBowl.tags}/>
          ))}
        </div>
      </div> 

      {/* Phadthai entrees */}
      <div className='app__specialMenu-menu_phadThai flex__center'>
        <p className='app__specialMenu-menu_heading'>Phad Thai Entrees</p>
        <div className='app__specialMenu_menu_items'>
          {data.phadThai.map((phadThai, index) => (
            <MenuItem key={phadThai.title + index} title={phadThai.title} price={phadThai.price} tags={phadThai.tags}/>
          ))}
        </div>
      </div> 

    {/* Pho entrees */}
    <div className='app__specialMenu-menu_pho flex__center'>
        <p className='app__specialMenu-menu_heading'>Pho Noodles Entrees</p>
        <div className='app__specialMenu_menu_items'>
          {data.pho.map((pho, index) => (
            <MenuItem key={pho.title + index} title={pho.title} price={pho.price} tags={pho.tags}/>
          ))}
        </div>
      </div>

    {/* Lomein entrees */}
    <div className='app__specialMenu-menu_loMein flex__center'>
        <p className='app__specialMenu-menu_heading'>Lo Mein Entrees</p>
        <div className='app__specialMenu_menu_items'>
          {data.loMein.map((loMein, index) => (
            <MenuItem key={loMein.title + index} title={loMein.title} price={loMein.price} tags={loMein.tags}/>
          ))}
        </div>
      </div>

    {/* Vegetarian entrees */}
      <div className='app__specialMenu-menu_vegetarian flex__center'>
        <p className='app__specialMenu-menu_heading'>Vegetarian Entrees</p>
        <div className='app__specialMenu_menu_items'>
          {data.vegetarian.map((vegetarian, index) => (
            <MenuItem key={vegetarian.title + index} title={vegetarian.title} price={vegetarian.price} tags={vegetarian.tags}/>
          ))}
        </div>
      </div>

    {/* EggFooYoung entrees */}
    <div className='app__specialMenu-menu_eggFooYoung flex__center'>
        <p className='app__specialMenu-menu_heading'>Egg Food Young Entrees</p>
        <div className='app__specialMenu_menu_items'>
          {data.eggFoo.map((eggFoo, index) => (
            <MenuItem key={eggFoo.title + index} title={eggFoo.title} price={eggFoo.price} tags={eggFoo.tags}/>
          ))}
        </div>
      </div>

    {/* drinks */}
    <div className='app__specialMenu-menu_drinks flex__center'>
        <p className='app__specialMenu-menu_heading'>Drinks</p>
        <div className='app__specialMenu_menu_items'>
          {data.drinks.map((drinks, index) => (
            <MenuItem key={drinks.title + index} title={drinks.title} price={drinks.price} tags={drinks.tags}/>
          ))}
        </div>
      </div>       
    </div>
  </div>
);

export default SpecialMenu;
